import "../src/styles/main.scss";

import { init as initSentry, captureException } from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import ky from "ky-universal";

import ConsoleOnlyError from "./utils/error/ConsoleOnlyError";
import { requestIdleCallback } from "./utils/requestIdleCallback";
import { IS_PROD } from "../constants/env";
import pkg from "../package.json";
import ReactGA4 from "react-ga4";

initSentry({
  dsn: "https://6ebb5a67acd64246b6ce7c0d037fe2fb@o616034.ingest.sentry.io/5751365",
  release: "linetv-web@" + pkg.version,
  environment: process.env.NODE_ENV,
  sampleRate: 1.0,
  allowUrls: [/linetv\.tw/],
  // integrations: [
  //   new Integrations.BrowserTracing({
  //     traceFetch: false,
  //     traceXHR: false,
  //   }),
  // ],
  tracesSampleRate: IS_PROD ? 0.005 : 1.0,
  defaultIntegrations: false,
  // async beforeSend(event, hint) {
  //   const error = hint.originalException;

  //   if (error instanceof ConsoleOnlyError) {
  //     console.error(error);
  //     return null;
  //   }

  //   if (error instanceof ky.TimeoutError) {
  //     console.error(error, error.request);
  //     return null;
  //   }

  //   if (error instanceof ky.HTTPError) {
  //     let body;

  //     try {
  //       body = await error.response.clone().json();
  //     } catch (error) {
  //       console.error(error);
  //     }

  //     console.error(error, body);
  //     return null;
  //   }

  //   return event;
  // },
});

setTimeout(() => {
  const React = require("react");
  const ReactDOM = require("react-dom");
  const Provider = require("react-redux").Provider;
  const BrowserRouter = require("react-router-dom").BrowserRouter;
  const loadableReady = require("@loadable/component").loadableReady;
  const SWRConfig = require("swr").SWRConfig;

  setTimeout(() => {
    const drama = require("./constants/actionTypes").drama;
    const AUTH_FLOW_BEGIN =
      require("./constants/actionTypes/user").AUTH_FLOW_BEGIN;
    const store = require("./store/configureStore").default(
      window.__INITIAL_STATE__
    );
    const root = document.getElementById("root");

    setTimeout(() => {
      const ReactGA = require("react-ga");
      const GA_ID = require("../constants/ga").GA_ID;
      const GA_ID_DEV = require("../constants/ga").GA_ID_DEV;
      const GA4_ID = require("../constants/ga").GA4_ID;
      const GA4_ID_DEV = require("../constants/ga").GA4_ID_DEV;

      ReactGA.initialize(IS_PROD ? GA_ID : GA_ID_DEV, {
        alwaysSendToDefaultTracker: false,
        standardImplementation: true,
      });

      ReactGA4.initialize(IS_PROD ? GA4_ID : GA4_ID_DEV);
      /**
       * @see {@link https://developers.google.com/analytics/devguides/collection/analyticsjs/debugging#testing_your_implementation_without_sending_hits}
       */
      if (!IS_PROD) {
        ReactGA.ga("set", "sendHitTask", null);
      }
    });

    setTimeout(() => {
      store.dispatch({ type: AUTH_FLOW_BEGIN });
    });

    setTimeout(() => {
      const fetcher = require("././utils/fetcher").default;
      const App = require("./App").default;

      loadableReady(() => {
        setTimeout(() => {
          ReactDOM.hydrate(
            <Provider store={store}>
              <BrowserRouter>
                <SWRConfig value={{ fetcher }}>
                  {/* <SWRConfig value={{ fetcher, onError: captureException }}> 若後續 SWR
                    若後續 SWR error 要加入 sentry 時可以補回來
                 */}
                  <App />
                </SWRConfig>
              </BrowserRouter>
            </Provider>,
            root
          );
        });
      });
    });

    setTimeout(() => {
      const ReactModal = require("react-modal");
      ReactModal.setAppElement(root);
    });

    requestIdleCallback(() => {
      store.dispatch({ type: drama.FETCH_DRAMA_SUMMARY });
    });

    requestIdleCallback(() => {
      store.dispatch({ type: drama.FETCH_DRAMA_CATEGORY });
    });
  });
});
